import script from "./Menu.vue?vue&type=script&lang=ts&setup=true"
export * from "./Menu.vue?vue&type=script&lang=ts&setup=true"

import "./Menu.vue?vue&type=style&index=0&id=2e092cc4&lang=less&scoped=true"

import exportComponent from "D:\\test\\ieds-user-end\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e092cc4"]])

export default __exports__